import { createPortal } from "react-dom";

// mui components
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  Typography,
} from "@mui/material";

// hooks
import useHttp from "hooks/use-http";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

// image
import logo from "assets/img/logo.png";

//helper
import Toast from "helper/toast";

// mui config
import { MuiThemeProivider } from "styles/mui-config";
import RTL from "styles/rtl-config";

import LoadingCM from "components/shared/Loading";

// styled cm
import {
  BackBtn,
  StyledContainer,
  StyledGrid,
  StyledImg,
  StyledTextField,
} from "./ForgotPassword.style";

// react icon
import { IoIosPerson } from "react-icons/io";
import { HiOutlineArrowRight } from "react-icons/hi";

// validate
import { getOtpCodeSchema } from "validations";
import { getOtpRequest, getTeacherOtpRequest, getUserInfoRequest } from "api/requests";
import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";

export default function GetTeacherOtpCode() {
  const navigate = useNavigate();

  const { loading, setLoading, request } = useHttp(false);

  const [userData, setUserData] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(getOtpCodeSchema),
  });

  const getUserInfo = useCallback(async () => {
    const res = await request({
      url: getUserInfoRequest,
    });

    if (res) {
      setUserData(res.data);
    }
  }, []);

  const onSubmit = async (data) => {
    if (userData.national_code !== data.username) {
      toast.error("نام کاربری اشتباه است", { position: "top-center" });
      return;
    }

    const res = await request({
      url: getTeacherOtpRequest,
    });
    if (res.data) {
      Toast({ type: "success", title: "ارسال کد " });
      navigate("/teacher/reset_password");
    }
  };

  useEffect(() => {
    getUserInfo();
  }, [getUserInfo]);

  return loading ? (
    <LoadingCM />
  ) : (
    createPortal(
      <>
        <MuiThemeProivider>
          <RTL>
            <div dir="rtl">
              <Stack
                direction={{ xs: "column", md: "row" }}
                sx={{ background: "#fff", display: "flex" }}
                height="100vh"
                justifyContent={"center"}
              >
                <BackBtn>
                  <Stack px={{ md: 15, xs: 5 }}>
                    <IconButton onClick={() => navigate(-1)}>
                      <HiOutlineArrowRight />
                    </IconButton>
                  </Stack>
                </BackBtn>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  width="100%"
                  display={{ md: "none" }}
                >
                  <StyledImg src={logo} alt="" />
                </Stack>
                <StyledContainer container>
                  <Grid item xs={12} md={7} lg={6} p={{ xs: 5, md: 0 }}>
                    <Stack
                      px={{ md: 15 }}
                      height={"100%"}
                      justifyContent="center"
                      alignItems="center"
                      spacing={4}
                    >
                      <Typography
                        variant="h4"
                        component={"h2"}
                        fontWeight={"bold"}
                        color="primary"
                        fontFamily={"Aviny"}
                      >
                        دریافت کد امنیتی
                      </Typography>
                      <StyledTextField
                        label="نام کاربری"
                        variant="filled"
                        size="small"
                        fullWidth
                        id="username"
                        {...register("username")}
                        error={Boolean(errors.username)}
                        helperText={errors.username?.message}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IoIosPerson />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Button
                        onClick={handleSubmit(onSubmit)}
                        variant="contained"
                        fullWidth
                        sx={{
                          fontFamily: "Aviny",
                          fontSize: "1.5rem",
                          padding: 0,
                        }}
                      >
                        دریافت کد
                      </Button>
                    </Stack>
                  </Grid>
                  <StyledGrid item />
                </StyledContainer>
              </Stack>
            </div>
          </RTL>
        </MuiThemeProivider>
      </>,
      document.getElementById("login")
    )
  );
}
